// DispatchModal.js
import React, { useState } from "react";
import { toast } from "react-toastify";

import "./dispatchModal.css"; // ✅ new CSS for styling

export default function DispatchModal({ open, onClose, onSubmit }) {
  const [form, setForm] = useState({
    transportName: "",
    dispatchDate: "",
    llrNumber: "",
  });

  if (!open) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.transportName || !form.dispatchDate || !form.llrNumber) {
      toast.warning("Please fill all fields");
      return;
    }
    onSubmit(form);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">🚚 Dispatch Details</h2>

        <label>
          🚛 Transport Name
          <input
          className="admin-transport"
            type="text"
            name="transportName"
            placeholder="Enter transport name"
            value={form.transportName}
            onChange={handleChange}
          />
        </label>

        <label>
          📅 Dispatch Date
          <input
          className="admin-transport"
            type="date"
            name="dispatchDate"
            value={form.dispatchDate}
            onChange={handleChange}
          />
        </label>

        <label>
          📦 LLR Number
          <input
          className="admin-transport"
            type="text"
            name="llrNumber"
            placeholder="Enter LLR number"
            value={form.llrNumber}
            onChange={handleChange}
          />
        </label>

        <div className="modal-actions">
          <button className="btn save" onClick={handleSubmit}>💾 Save</button>
          <button className="btn cancel" onClick={onClose}>❌ Cancel</button>
        </div>
      </div>
    </div>
  );
}
